/** A piece of a changelog entry: its inline Markdown is limited to `code` and **strong** (spec 04, 6.13). */
export interface InlinePart {
  kind: 'text' | 'code' | 'strong';
  text: string;
}

const INLINE = /`([^`]+)`|\*\*([^*]+)\*\*/g;

/** Splits text into plain, code and strong parts; anything else (links, HTML) stays plain text. */
export function parseInline(text: string): InlinePart[] {
  const parts: InlinePart[] = [];
  let last = 0;
  for (const match of text.matchAll(INLINE)) {
    if (match.index > last) parts.push({ kind: 'text', text: text.slice(last, match.index) });
    parts.push(
      match[1] !== undefined ? { kind: 'code', text: match[1] } : { kind: 'strong', text: match[2] },
    );
    last = match.index + match[0].length;
  }
  if (last < text.length) parts.push({ kind: 'text', text: text.slice(last) });
  return parts;
}
